<template lang="html">
  <div v-if="showLoader" class="loadingPage">
    <svg class="loadingPage__svg" viewBox="25 25 50 50">
      <circle
        class="loadingPage__path"
        cx="50"
        cy="50"
        r="20"
        fill="none"
        stroke="#ff6e00"
        stroke-width="2"
      />
    </svg>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'Loading',
  computed: {
    ...mapState('layout', ['showLoader']),
  },
  methods: {
    ...mapMutations({
      setLoader: 'layout/setLoader',
    }),
    start() {
      this.setLoader(true);
    },
    finish() {
      // this.setLoader(false);
    },
    finishCreate() {
      this.setLoader(false);
    },
  },
};
</script>

<style lang="scss" scoped>
.loadingPage {
  position: fixed;
  z-index: $zIndexLoader;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);

  &__svg {
    position: absolute;
    left: calc(50% - 50px);
    top: calc(50% - 50px);
    animation: rotate 2s linear infinite;
    height: 100px;
    transform-origin: center center;
    width: 100px;
    margin: auto;
  }

  &__path {
    stroke-dasharray: 150, 200;
    stroke-dashoffset: -10;
    animation: dash 1.5s ease-in-out infinite;
    stroke-linecap: round;
  }
}
@-webkit-keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124;
  }
}
</style>
